import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signin } from "../actions/authActions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginScreen = ({ history }) => {
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { loading, error, userInfo } = userLogin;
  console.log("userInfo",userInfo)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  };

  const findFormErrors = () => {
    const { email, password } = formValues;
    const newErrors = {};
    if (!email) newErrors.email = "This field is required";
    else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      newErrors.email = "Please use a valid email format";
    }
    if (!password) newErrors.password = "This field is required";
    else if (password.length < 8)
      newErrors.password = "Password must be at least 8 characters";
    return newErrors;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const result = await dispatch(signin(formValues.email, formValues.password)); 
      if (result.success) {
        history.push("/dashboard");
      }
    }
  };

  return (
    <div className="login-container">
      <ToastContainer />
      {error && <p className="error-message">{error}</p>}
      <section>
        <div className="row">
          <div className="col-lg-6">
            <h3>Login</h3>
            <div>
              <form onSubmit={submitHandler}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="text"
                    className={`form-control mb-0 ${errors.email ? "is-invalid" : ""}`}
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    onChange={handleChange}
                    value={formValues.email}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className={`form-control mb-0 ${errors.password ? "is-invalid" : ""}`}
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    onChange={handleChange}
                    value={formValues.password}
                  />
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </div>
                <button
                  type="submit"
                  className="btn btn-danger"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
                <Link className="px-3" to={`${process.env.PUBLIC_URL}/forget-password`}>
                  Forgot password?
                </Link>
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <h3>Welcome</h3>
            <p>
              Sign up for a free account. Registration is quick and easy.
            </p>
            <Link to="/register/merchant" className="btn btn-danger">
              {/* Register as Retailer */}
              Register
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginScreen;
